import normalizeString from '../../utilities/function/normalizeString';
import Historias from '../../historias';
const MenuOpciones = () => {
  let opciones = [];
  Historias.forEach(item => {
    opciones.push(
      {
        titulo: item.titulo,
        ciudad: item.ciudad,
        departamento: item.departamento,
        imagen: item.imagen,
        link: `/contenido/${normalizeString(item.titulo)}`
      }
    )
  })
  return opciones;
}

export default MenuOpciones;